import { QueryClient, VueQueryPlugin, type VueQueryPluginOptions } from '@tanstack/vue-query'

// Globalna instancja queryClient dostępna wszędzie
let globalQueryClient: QueryClient | null = null

export const getQueryClient = (): QueryClient => {
	if (!globalQueryClient) {
		throw new Error('QueryClient is not initialized yet. Make sure the vue-query plugin has been loaded.')
	}

	return globalQueryClient
}

export default defineNuxtPlugin(nuxt => {
	// Modify your Vue Query global settings here
	const queryClient = new QueryClient({
		// After 1 week its considered stale.
		defaultOptions: {
			queries: {
				staleTime: DAYS_IN_WEEK * 24 * 3600 * 1000,
				gcTime: DAYS_IN_WEEK * 24 * 3600 * 1000,
			},
		},
	})

	// Ustaw globalną instancję
	globalQueryClient = queryClient

	const options: VueQueryPluginOptions = { queryClient }

	nuxt.vueApp.use(VueQueryPlugin, options)
})
